import React from "react";
import { hadleFilter } from "../../../Utils/filtroBusqueda";

import { InputSearchDNI } from "../../../Components/FormElements/InputSearchDNI";

import IconDelete from "../../../Resources/svg/Icons/IconDelete";

export const InputsSearchByDNI = ({
  handleChangeState,
  options,
  searchInput,
  handleChangeSearch,
  handleSearchClick,
  handleChangeSelect,
  handleReset,
  codProd,
}: any) => {
  const isEmpty = searchInput === "" ? true : false;

  return (
    <>
      <select onChange={handleChangeState}>
        {hadleFilter(codProd).map(({ value, lable }: any) => (
          <option key={value} value={value}>{lable}</option>
        ))}
      </select>
      <InputSearchDNI
        values={options}
        value={searchInput}
        onChangeInput={handleChangeSearch}
        onChangeSelect={handleChangeSelect}
      />
      <button
        type="submit"
        className="btn"
        onClick={handleSearchClick}
        disabled={isEmpty}
      >
        Continuar
      </button>
      <div className="clean-filter" onClick={handleReset}>
        <IconDelete /> Borrar filtros
      </div>
    </>
  );
};
